.ap{flex:1;}